var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-overlay-custom'),_c('error-modal'),_c('generic-header'),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1),_c('generic-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }